import BasicText from "@/components/BasicText";
import Subtitle from "@/components/Subtitle";
import BigEllipse from "@/components/svg/ellipse/BigEllipse";
import Title from "@/components/Title";

import Image from "@/components/Image";
import backersGlassEffect from "@/assets/images/backers-glass-effect.svg";
import backersPolygon from "@/assets/images/backers-polygon.png";

import LightBox from "@/components/svg/SampleLogos/LightBox";
import ZentrySvg from "@/components/svg/SampleLogos/ZentrySvg";
import Segment from "@/components/svg/SampleLogos/Segment";
import AcmeCorp from "@/components/svg/SampleLogos/AcmeCorp";
import ChartySvg from "@/components/svg/SampleLogos/ChartySvg";
import Luminous from "@/components/svg/SampleLogos/Luminous";

import Partner from "../home/Partner";

const Partners: React.FC = () => {
  const backers = [AcmeCorp, ChartySvg, ZentrySvg, Segment, LightBox, Luminous];
  return (
    <div className="relative flex w-full flex-col md:flex-row px-16 py-20 gap-10 shadow-inner-glow overflow-hidden">
      <div className="absolute z-0 overflow-hidden w-full h-full">
        <Image
          className="absolute right-0"
          src={backersGlassEffect}
          alt="glass effect"
        />
      </div>

      <div className="flex flex-col lg:flex-row items-center justify-between w-full">
        <div className="flex flex-col z-30 w-[382px]">
          <Subtitle>// BACKED BY THE BEST</Subtitle>
          <Title className="mt-2">
            <h1>Backed by web3</h1>
            <h1 className="text-luminode-blue w-fit">industry veterans</h1>
          </Title>
          <BasicText className="mt-6" size="18px" color="faded">
            Worem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero.
          </BasicText>
        </div>

        <div className="flex flex-wrap gap-4 flex-1 justify-center my-20 lg:my-0 lg:justify-end">
          {backers.map((component) => {
            return (
              <Partner>
                {component()}
              </Partner>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Partners;
